import { render } from "./AdminDetails.vue?vue&type=template&id=ca85869a"
import script from "./AdminDetails.vue?vue&type=script&lang=js"
export * from "./AdminDetails.vue?vue&type=script&lang=js"
script.render = render

export default script